<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <section class="card-style-sec exposures-segs-sec info-popups">
      <div class="container-fluid">
        <div class="row segs-particle-risk-row">
          <div class="col-md-12 col-lg-12 border-right border-top">
            <div class="card-inner-main-div">
              <ng-container>
                <div class="white-box">
                  <div class="row">
                    <div class="col-lg-12 map-container">
                      <app-maplibre-realtime-map #realtimeMap [nodes]="nodes" [heatmapData]="heatmapData"
                        [heatmapImage]="heatmapImage" [showHeatmap]="showHeatmap"
                        [loading]="loading" (openNodeDetails)="openNodeDetails($event)"
                      (toggleHeatmapEmit)="toggleHeatmap($event)" [selectedNode]="selectedNode"></app-maplibre-realtime-map>
                      @if (noDataFound) {
                        <div class="no-data-overlay">
                          <span>{{ 'No nodes found' | translate }}</span>
                        </div>
                      }
                    </div>

                    <!-- <div class="col-lg-3 mt-2 right-list">
                    <div class="text-center controls-div">
                      <mat-label>Nodes</mat-label>
                    </div>
                    <hr class="toggle-underline" />

                    <div class="dashboard-toggle">
                      <mat-nav-list [@leftSlideInAnimation]>
                        <mat-list-item *ngIf="!nodes || nodes.length < 1">
                          N/A
                        </mat-list-item>
                        <a mat-list-item *ngFor="let node of nodes; trackBy: trackByIndex"
                          [title]="node.endPointName">
                          <mat-icon class="dashboard-icon mr-3">
                            <i class="fa-user fas"></i>
                          </mat-icon>
                          <mat-label
                          class="dashboard-label">{{node.endPointName}}</mat-label>
                        </a>
                      </mat-nav-list>
                    </div>
                  </div> -->
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row location-or-plan-row">
      </div>
    </div>
  </section>
</app-sidebar-layout>
</div>

<app-flyout-container #flyout></app-flyout-container>
